import { useCallback, useEffect, useState } from "react";

const getHeight = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

export const useHeight = () => {
  const [height, setHeight] = useState(getHeight());

  const _watch = useCallback(() => {
      const h = getHeight();
      setHeight(h);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', _watch);
    return () => {
      window.removeEventListener('resize', _watch);
    }
  }, [_watch]);

  return { height };
}
